"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTivNonceError = exports.CreateTivNonceResponse = exports.CreateTivNonceRequest = exports.CreateTivNonceError_Enum = void 0;
const uuid_1 = require("../../../core/uuid");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enums indicating a non-retryable error for the CreateTivNonce endpoint */
var CreateTivNonceError_Enum;
(function (CreateTivNonceError_Enum) {
    /** UNSET - Default enum value */
    CreateTivNonceError_Enum[CreateTivNonceError_Enum["UNSET"] = 0] = "UNSET";
    /**
     * NO_ERROR - Explicitly indicates that no error occurred for the request. This enum is preferred over `UNSET` since addition
     * of new non-retryable errors may result in client code breaking as those new errors would be returned as `UNSET`
     * if the pb_schema version is not up to date
     */
    CreateTivNonceError_Enum[CreateTivNonceError_Enum["NO_ERROR"] = 1] = "NO_ERROR";
    /** USER_NOT_FOUND - User ID does not belong to any valid User */
    CreateTivNonceError_Enum[CreateTivNonceError_Enum["USER_NOT_FOUND"] = 2] = "USER_NOT_FOUND";
    CreateTivNonceError_Enum[CreateTivNonceError_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CreateTivNonceError_Enum = exports.CreateTivNonceError_Enum || (exports.CreateTivNonceError_Enum = {}));
function createBaseCreateTivNonceRequest() {
    return { userId: undefined, broadcastId: undefined, communicationChannel: 0 };
}
exports.CreateTivNonceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== undefined) {
            uuid_1.UUID.encode(message.userId, writer.uint32(10).fork()).ldelim();
        }
        if (message.broadcastId !== undefined) {
            uuid_1.UUID.encode(message.broadcastId, writer.uint32(18).fork()).ldelim();
        }
        if (message.communicationChannel !== 0) {
            writer.uint32(24).int32(message.communicationChannel);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateTivNonceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.broadcastId = uuid_1.UUID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.communicationChannel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCreateTivNonceRequest();
        message.userId =
            object.userId !== undefined && object.userId !== null
                ? uuid_1.UUID.fromPartial(object.userId)
                : undefined;
        message.broadcastId =
            object.broadcastId !== undefined && object.broadcastId !== null
                ? uuid_1.UUID.fromPartial(object.broadcastId)
                : undefined;
        message.communicationChannel = object.communicationChannel ?? 0;
        return message;
    },
};
function createBaseCreateTivNonceResponse() {
    return { nonce: "", error: 0 };
}
exports.CreateTivNonceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.nonce !== "") {
            writer.uint32(10).string(message.nonce);
        }
        if (message.error !== 0) {
            writer.uint32(16).int32(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateTivNonceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.string();
                    break;
                case 2:
                    message.error = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCreateTivNonceResponse();
        message.nonce = object.nonce ?? "";
        message.error = object.error ?? 0;
        return message;
    },
};
function createBaseCreateTivNonceError() {
    return {};
}
exports.CreateTivNonceError = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateTivNonceError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseCreateTivNonceError();
        return message;
    },
};
//# sourceMappingURL=create_tiv_nonce.js.map